import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICONS } from '../icons';
import AppInput from './AppInput';

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languageOptions = [
    { value: "en", labelKey: "common.english" },
    { value: "nl", labelKey: "common.dutch" }
  ];

  return (
    <div className="language-switcher">
      <AppInput
        type="select"
        id="language-select"
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        variant="language-select"
        options={languageOptions}
      />
    </div>
  );
} 